import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from "../../../api.service";

@Component({
  selector: 'app-medicine-dispensing-visit',
  templateUrl: './medicine-dispensing-visit.component.html',
  styleUrls: ['./medicine-dispensing-visit.component.scss']
})
export class MedicineDispensingVisitComponent implements OnInit {
  formName: string | null = null; // To store the formName parameter
  studyId: string | null = null;
  subjectId: string | null = null;
  queryParams: any = {};
  studyDetails: any;
  subjectName: any;
  dataEntryDisabled: boolean = false;

  // Form data model
  formData = {
    visitNo: null,
    visitDate: '',
    vitalSigns: '',
    vitalSignsComments: '',
    pregnancyStatus: '',
    weight: null,
    height: null,
    waistCircumference: null,
    weightLossPrevious: null,
    weightLossBaseline: null,
    waistDifferencePrevious: null,
    waistDifferenceBaseline: null,
    productRetrieved: '',
    productRetrievedComments: '',
    asanaDispensedPrevious: null,
    asanaQuantityPrevious: null,
    asanaRetrievedCurrent: null,
    triphalaDispensedPrevious: null,
    triphalaQuantityPrevious: null,
    triphalaRetrievedCurrent: null,
    yavaDispensedPrevious: null,
    yavaQuantityPrevious: null,
    yavaRetrievedCurrent: null,
    asanaCompliance: '',
    asanaFirstDate: '',
    asanaLastDate: '',
    asanaConsumed: null,
    asanaIdealConsumed: null,
    asanaMissed: null,
    asanaCompliancePercentage: null,
    triphalaCompliance: '',
    triphalaFirstDate: '',
    triphalaLastDate: '',
    triphalaConsumed: null,
    triphalaIdealConsumed: null,
    triphalaMissed: null,
    triphalaCompliancePercentage: null,
    yavaCompliance: '',
    yavaFirstDate: '',
    yavaLastDate: '',
    yavaConsumed: null,
    yavaIdealConsumed: null,
    yavaMissed: null,
    yavaCompliancePercentage: null,
    dispensedProtocol: '',
    logGiven: '',
    dispensingDate: '',
    asanaDispensedCurrent: null,
    asanaQuantityCurrent: null,
    asanaBatch: null,
    asanaExpiry: '',
    triphalaDispensedCurrent: null,
    triphalaQuantityCurrent: null,
    triphalaBatch: null,
    triphalaExpiry: '',
    yavaDispensedCurrent: null,
    yavaQuantityCurrent: null,
    yavaBatch: null,
    yavaExpiry: '',
    adverseEvent: '',
    concomitantMedication: '',
    investigatorSignature: '',
    endDate: '',
    studyComments:'',
    triphalaComplianceComments:'',
    yavaComplianceComments:'',
    studyComplianceComments:'',
    logGivenComments:'',
    dispensedProtocolComments:'',
    lmpDate: '',     // Date of Last Menstrual Period
    uptDone: '',     // Urine Pregnancy Test done (Yes/No)
    uptResult: '',
  };
  studyCode: any;
  studyName: any;
  siteLocation: any;
  todayDate: string;
  screeningMinDate: string;
  
  private questionMapping: { [key: string]: { question: string, field: string }[] } = {
    'medicine-dispensing-visit-date': [
        { question: '1. Medicine Dispensing Visit No.:', field: 'visitNo' },
        { question: '2. Date of Visit:', field: 'visitDate' }
    ],
    'medicine-vital-signs': [
      { question: '1. Was Vital Signs evaluation performed?', field: 'vitalSigns' },
  ],
   'medicine-pregnancy-declaration':[
    { question: 'Date of Last Menstrual Period (LMP)', field: 'lmpDate' },
  { question: 'Was Urine Pregnancy Test (UPT) done?', field: 'uptDone' },
  { question: 'UPT Result', field: 'uptResult' }
   ],
   'medicine-anthropometric-data': [
        { question: '1. Weight (kg):', field: 'weight' },
        { question: '2. Height (m):', field: 'height' },
        { question: '3. Waist Circumference (cm):', field: 'waistCircumference' },
        { question: '4. Weight-loss from previous visit (kg):', field: 'weightLossPrevious' },
        { question: '5. Weight-loss since baseline visit (kg):', field: 'weightLossBaseline' },
        { question: '6. Difference in Waist circumference from previous visit (cm):', field: 'waistDifferencePrevious' },
        { question: '7. Difference in Waist circumference since baseline visit (cm):', field: 'waistDifferenceBaseline' }
    ],
    'medicine-product-retrieval':[
      { question: 'Was the Study Product retrieved from subject as per protocol?', field: 'productRetrieved'},
    ],
    'medicine-product-accountability': [
      { question: 'Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):', field: 'asanaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):', field: 'asanaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):', field: 'asanaRetrievedCurrent' },
      
      { question: 'Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):', field: 'triphalaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):', field: 'triphalaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Triphala tablet):', field: 'triphalaRetrievedCurrent' },

      { question: 'Total Number of sachets/boxes dispensed in previous visit (Yava Churna):', field: 'yavaDispensedPrevious' },
      { question: 'Total Study Product quantity dispensed in previous visit (g) (Yava Churna):', field: 'yavaQuantityPrevious' },
      { question: 'Total Number of sachets/boxes retrieved in current visit (Yava Churna):', field: 'yavaRetrievedCurrent' }
    ],
    'medicine-product-compliance': [
    { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)?', field: 'asanaCompliance' },
    { question: 'Date of first Study Product consumed (Asana Churna):', field: 'asanaFirstDate' },
    { question: 'Date of last Study Product consumed (Asana Churna):', field: 'asanaLastDate' },
    { question: 'Total quantity of Study Product consumed (g) (Asana Churna):', field: 'asanaConsumed' },
    { question: 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):', field: 'asanaIdealConsumed' },
    { question: 'Total quantity missed (Asana Churna):', field: 'asanaMissed' },
    { question: 'Compliance (%) (Asana Churna):', field: 'asanaCompliancePercentage' },
    // Repeat the same for Triphala and Yava Churna
    { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)?', field: 'triphalaCompliance' },
    { question: 'Date of first Study Product consumed (Triphala):', field: 'triphalaFirstDate' },
    { question: 'Date of last Study Product consumed (Triphala):', field: 'triphalaLastDate' },
    { question: 'Total quantity of Study Product consumed (g) (Triphala):', field: 'triphalaConsumed' },
    { question: 'Total quantity of Study Product should ideally be consumed (g) (Triphala):', field: 'triphalaIdealConsumed' },
    { question: 'Total quantity missed (Triphala):', field: 'triphalaMissed' },
    { question: 'Compliance (%) (Triphala):', field: 'triphalaCompliancePercentage' },
    { question: 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)?', field: 'yavaCompliance' },
    { question: 'Date of first Study Product consumed (Yava Churna):', field: 'yavaFirstDate' },
    { question: 'Date of last Study Product consumed (Yava Churna):', field: 'yavaLastDate' },
    { question: 'Total quantity of Study Product consumed (g) (Yava Churna):', field: 'yavaConsumed' },
    { question: 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):', field: 'yavaIdealConsumed' },
    { question: 'Total quantity missed (Yava Churna):', field: 'yavaMissed' },
    { question: 'Compliance (%) (Yava Churna):', field: 'yavaCompliancePercentage' },
  ],
  'medicine-product-dispensing-record': [
    { question: '1. Were all the Study Products dispensed to the subject as per protocol?', field: 'dispensedProtocol' },
    { question: '3. Was the Daily Product Consumption Log given to the subject?', field: 'logGiven' },
    { question: '5. Date of dispensing of the Study Products:', field: 'dispensingDate' },
    { question: '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):', field: 'asanaDispensedCurrent' },
    { question: '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):', field: 'asanaQuantityCurrent' },
    { question: '8. Batch Number (Asana Churna herbal drink):', field: 'asanaBatch' },
    { question: '9. Date of Expiry (Asana Churna herbal drink):', field: 'asanaExpiry' },
    { question: '10. Total Number of sachets/boxes dispensed (Triphala tablet):', field: 'triphalaDispensedCurrent' },
    { question: '11. Total Study Product quantity dispensed (g) (Triphala tablet):', field: 'triphalaQuantityCurrent' },
    { question: '12. Batch Number (Triphala tablet):', field: 'triphalaBatch' },
    { question: '13. Date of Expiry (Triphala tablet):', field: 'triphalaExpiry' },
    { question: '14. Total Number of sachets/boxes dispensed (Yava Churna):', field: 'yavaDispensedCurrent' },
    { question: '15. Total Study Product quantity dispensed (g) (Yava Churna):', field: 'yavaQuantityCurrent' },
    { question: '16. Batch Number (Yava Churna):', field: 'yavaBatch' },
    { question: '17. Date of Expiry (Yava Churna):', field: 'yavaExpiry' }
],
'medicine-adverse-events': [
        { question: 'Did the subject experience any adverse event since last visit?', field: 'adverseEvent' },
        { question: 'Did the subject take any new or change in concomitant medications since last visit?', field: 'concomitantMedication' }
    ],
    'medicine-end-visit': [
        { question: 'Principal Investigator’s Signature:', field: 'investigatorSignature' },
        { question: 'Date:', field: 'endDate' }
    ]

  };
  folderName: any;
  informedConsentDate: string;
  gender: any;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = today.getFullYear();
    this.todayDate = `${year}-${month}-${day}`;
  
    this.informedConsentDate = ''; // Start with an empty value
    this.screeningMinDate = ''; // Same for screeningMinDate
  
    // Get the formName parameter from the route
    this.route.paramMap.subscribe(params => {
      this.folderName = params['folderName'] ?? 'medicine-dispensing-visit';;
      this.formName = params.get('formName');
      console.log('Form Name:', this.formName,'folder name',this.folderName); // Debugging log
    });

    // Get query parameters (studyId and subjectId)
    this.route.queryParams.subscribe(params => {
      this.studyId = params['studyId'];
      this.subjectId = params['subjectId'];
      console.log('Study ID:', this.studyId); // Debugging log
      console.log('Subject ID:', this.subjectId); // Debugging log
    });
    console.log("Extracted Params:", {
      studyId: this.studyId,
      subjectId: this.subjectId,
      folderName: this.folderName,
      formName: this.formName
    });
    if (this.studyId && this.subjectId && this.folderName && this.formName) {
      this.apiService.getFormData(this.studyId, this.subjectId, this.folderName, this.formName).subscribe({
        next: (response) => {
          console.log('Fetched Form Data:', response);
          if (response.success) {
           // Ensure response.data is an array before mapping
           if (Array.isArray(response.data)) {
            this.mapFormData(response.data);
          } else {
            console.warn('Form data is not an array or is missing.');
          }
          this.mapStudyDetails(response.studyDetails);

          // Dynamically update informedConsentDate from the response
          if (response.informedConsentDate !== undefined) {
            this.informedConsentDate = response.informedConsentDate;
            this.screeningMinDate = this.informedConsentDate;  // Set min date
            console.log("Informed Consent Date:", this.informedConsentDate);
          } else {
            console.warn('Informed consent date is missing in the response.');
          }
           // Store the gender from the response
           this.gender = response.gender;
           console.log("gender:",this.gender);
        }
        },
        error: (error) => {
          console.error('Error fetching form data:', error);
        }
      });
    }
  }

  mapStudyDetails(studyDetails: any): void {
    if (studyDetails) {
      this.studyCode = studyDetails.study_code;
      this.studyName = studyDetails.study_name;
      this.siteLocation = studyDetails.site_location;
      this.subjectName = this.subjectId; // Mapping subjectId to subjectName
    }
  }

  mapFormData(data: any[]): void {
    data.forEach(item => {
      const fieldName = item.field_name?.trim();
      const fieldValue = item.value;

      switch (fieldName) {
        case '1. Medicine Dispensing Visit No.:':
          this.formData.visitNo = fieldValue;
          break;
        case '2. Date of Visit:':
          this.formData.visitDate = fieldValue;
          break;
        case '1. Was Vital Signs evaluation performed?':
          this.formData.vitalSigns = fieldValue;
          if (fieldValue === 'no') {
            this.formData.vitalSignsComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
          }
          break;

          case 'Date of Last Menstrual Period (LMP)':
            this.formData.lmpDate = fieldValue; // Store LMP Date
            break;
          
          case 'Was Urine Pregnancy Test (UPT) done?':
            this.formData.uptDone = fieldValue; // Store UPT Done (YES/NO)
            break;
          
          case 'UPT Result':
            this.formData.uptResult = fieldValue; // Store UPT Result (Positive/Negative)
            break;

          case '1. Weight (kg):':
            this.formData.weight = fieldValue;
            break;
          case '2. Height (m):':
            this.formData.height = fieldValue;
            break;
          case '3. Waist Circumference (cm):':
            this.formData.waistCircumference = fieldValue;
            break;
          case '4. Weight-loss from previous visit (kg):':
            this.formData.weightLossPrevious = fieldValue;
            break;
          case '5. Weight-loss since baseline visit (kg):':
            this.formData.weightLossBaseline = fieldValue;
            break;
          case '6. Difference in Waist circumference from previous visit (cm):':
            this.formData.waistDifferencePrevious = fieldValue;
            break;
          case '7. Difference in Waist circumference since baseline visit (cm):':
            this.formData.waistDifferenceBaseline = fieldValue;
            break;
          case 'Was the Study Product retrieved from subject as per protocol?':
            this.formData.productRetrieved = fieldValue;
            if (fieldValue === 'no') {
              this.formData.studyComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
            }
            break;
            case "Total Number of sachets/boxes dispensed in previous visit (Asana Churna herbal drink):":
              this.formData.asanaDispensedPrevious = item.value;
              break;
            case "Total Study Product quantity dispensed in previous visit (g) (Asana Churna herbal drink):":
              this.formData.asanaQuantityPrevious = item.value;
              break;
            case "Total Number of sachets/boxes retrieved in current visit (Asana Churna herbal drink):":
              this.formData.asanaRetrievedCurrent = item.value;
              break;
            case "Total Number of sachets/boxes dispensed in previous visit (Triphala tablet):":
              this.formData.triphalaDispensedPrevious = item.value;
              break;
            case "Total Study Product quantity dispensed in previous visit (g) (Triphala tablet):":
              this.formData.triphalaQuantityPrevious = item.value;
              break;
            case "Total Number of sachets/boxes retrieved in current visit (Triphala tablet):":
              this.formData.triphalaRetrievedCurrent = item.value;
              break;
            case "Total Number of sachets/boxes dispensed in previous visit (Yava Churna):":
              this.formData.yavaDispensedPrevious = item.value;
              break;
            case "Total Study Product quantity dispensed in previous visit (g) (Yava Churna):":
              this.formData.yavaQuantityPrevious = item.value;
              break;
            case "Total Number of sachets/boxes retrieved in current visit (Yava Churna):":
              this.formData.yavaRetrievedCurrent = item.value;
              break;
            //study compliance
            case 'Is the subject compliant with the usage of Study Product as per the protocol (Asana Churna)?':
                this.formData.asanaCompliance = fieldValue;
                if (fieldValue === 'no') {
                    this.formData.studyComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
                }
                break;

            case 'Date of first Study Product consumed (Asana Churna):':
                this.formData.asanaFirstDate = fieldValue;
                break;

            case 'Date of last Study Product consumed (Asana Churna):':
                this.formData.asanaLastDate = fieldValue;
                break;

            case 'Total quantity of Study Product consumed (g) (Asana Churna):':
                this.formData.asanaConsumed = fieldValue;
                break;

            case 'Total quantity of Study Product should ideally be consumed (g) (Asana Churna):':
                this.formData.asanaIdealConsumed = fieldValue;
                break;

            case 'Total quantity missed (Asana Churna):':
                this.formData.asanaMissed = fieldValue;
                break;

            case 'Compliance (%) (Asana Churna):':
                this.formData.asanaCompliancePercentage = fieldValue;
                break;

            case 'Is the subject compliant with the usage of Study Product as per the protocol (Triphala)?':
                this.formData.triphalaCompliance = fieldValue;
                if (fieldValue === 'no') {
                    this.formData.triphalaComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
                }
                break;

            case 'Date of first Study Product consumed (Triphala):':
                this.formData.triphalaFirstDate = fieldValue;
                break;

            case 'Date of last Study Product consumed (Triphala):':
                this.formData.triphalaLastDate = fieldValue;
                break;

            case 'Total quantity of Study Product consumed (g) (Triphala):':
                this.formData.triphalaConsumed = fieldValue;
                break;

            case 'Total quantity of Study Product should ideally be consumed (g) (Triphala):':
                this.formData.triphalaIdealConsumed = fieldValue;
                break;

            case 'Total quantity missed (Triphala):':
                this.formData.triphalaMissed = fieldValue;
                break;

            case 'Compliance (%) (Triphala):':
                this.formData.triphalaCompliancePercentage = fieldValue;
                break;

            case 'Is the subject compliant with the usage of Study Product as per the protocol (Yava Churna)?':
                this.formData.yavaCompliance = fieldValue;
                if (fieldValue === 'no') {
                    this.formData.yavaComplianceComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
                }
                break;

            case 'Date of first Study Product consumed (Yava Churna):':
                this.formData.yavaFirstDate = fieldValue;
                break;

            case 'Date of last Study Product consumed (Yava Churna):':
                this.formData.yavaLastDate = fieldValue;
                break;

            case 'Total quantity of Study Product consumed (g) (Yava Churna):':
                this.formData.yavaConsumed = fieldValue;
                break;

            case 'Total quantity of Study Product should ideally be consumed (g) (Yava Churna):':
                this.formData.yavaIdealConsumed = fieldValue;
                break;

            case 'Total quantity missed (Yava Churna):':
                this.formData.yavaMissed = fieldValue;
                break;

            case 'Compliance (%) (Yava Churna):':
                this.formData.yavaCompliancePercentage = fieldValue;
                break;
              // Study Product Dispensing Record Form
                case '1. Were all the Study Products dispensed to the subject as per protocol?':
                  this.formData.dispensedProtocol = fieldValue;
                  if (fieldValue === 'no') {
                    this.formData.dispensedProtocolComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
                  }
                  break;
                case '3. Was the Daily Product Consumption Log given to the subject?':
                  this.formData.logGiven = fieldValue;
                  if (fieldValue === 'no') {
                    this.formData.logGivenComments = item.sub_data ? item.sub_data.replace(/\\n/g, '\n') : null;
                  }
                  break;
                case '5. Date of dispensing of the Study Products:':
                  this.formData.dispensingDate = fieldValue;
                  break;
                case '6. Total Number of sachets/boxes dispensed (Asana Churna herbal drink):':
                  this.formData.asanaDispensedCurrent = fieldValue;
                  break;
                case '7. Total Study Product quantity dispensed (g) (Asana Churna herbal drink):':
                  this.formData.asanaQuantityCurrent = fieldValue;
                  break;
                case '8. Batch Number (Asana Churna herbal drink):':
                  this.formData.asanaBatch = fieldValue;
                  break;
                case '9. Date of Expiry (Asana Churna herbal drink):':
                  this.formData.asanaExpiry = fieldValue;
                  break;
                case '10. Total Number of sachets/boxes dispensed (Triphala tablet):':
                  this.formData.triphalaDispensedCurrent = fieldValue;
                  break;
                case '11. Total Study Product quantity dispensed (g) (Triphala tablet):':
                  this.formData.triphalaQuantityCurrent = fieldValue;
                  break;
                case '12. Batch Number (Triphala tablet):':
                  this.formData.triphalaBatch = fieldValue;
                  break;
                case '13. Date of Expiry (Triphala tablet):':
                  this.formData.triphalaExpiry = fieldValue;
                  break;
                case '14. Total Number of sachets/boxes dispensed (Yava Churna):':
                  this.formData.yavaDispensedCurrent = fieldValue;
                  break;
                case '15. Total Study Product quantity dispensed (g) (Yava Churna):':
                  this.formData.yavaQuantityCurrent = fieldValue;
                  break;
                case '16. Batch Number (Yava Churna):':
                  this.formData.yavaBatch = fieldValue;
                  break;
                case '17. Date of Expiry (Yava Churna):':
                  this.formData.yavaExpiry = fieldValue;
                  break;
                  case 'Did the subject experience any adverse event since last visit?':
                    this.formData.adverseEvent = fieldValue;
                    break;
                case 'Did the subject take any new or change in concomitant medications since last visit?':
                    this.formData.concomitantMedication = fieldValue;
                    break;
                case 'Principal Investigator’s Signature:':
                    this.formData.investigatorSignature = fieldValue;
                    break;
                case 'Date:':
                    this.formData.endDate = fieldValue;
                    break;


        // Add more cases for other fields...
        default:
          console.warn(`No mapping found for field: ${fieldName}`);
          break;
      }
    });
  }

  toggleComments(elementId: string, show: boolean): void {
    const element = document.getElementById(elementId);
    if (element) {
      element.style.display = show ? 'block' : 'none';
    }
  }
  handleUptResultChange(): void {
    if (this.formData.uptResult === 'Positive') {
      alert('As the UPT test is positive, kindly exclude the patient from the study.');
    }
  }
  

  calculateCompliance(section: string): void {
    const consumed = Number(this.formData[`${section}Consumed`]);
    const idealConsumed = Number(this.formData[`${section}IdealConsumed`]);
  
    if (idealConsumed > 0) {
      const compliancePercentage = ((consumed / idealConsumed) * 100).toFixed(2);
      this.formData[`${section}CompliancePercentage`] = compliancePercentage;
    } else {
      this.formData[`${section}CompliancePercentage`] = null;
    }
  }
  navigateToConcomitantMedication(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/concomitant-medication/concomitant-medication-log'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToAdverseEvents(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/adverse-events/adverse-event-report'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  navigateToVitalSigns(): void {
    if (this.studyId && this.subjectId) {
      this.router.navigate(['/folders/vital-signs/vital-signs'], {
        queryParams: { studyId: this.studyId, subjectId: this.subjectId }
      });
    } else {
      console.error('Missing studyId or subjectId');
    }
  }
  validateForm() {
    const weightPattern = /^\d{3}\.\d{2}$/;
    const heightPattern = /^\d{2}\.\d{2}$/;
    const waistPattern = /^\d{3}\.\d{2}$/;
    const  weightLossPreviousPattern= /^\d{3}\.\d{2}$/;
    const  weightLossBaselinePattern= /^\d{3}\.\d{2}$/;
    const   waistDifferencePreviousPattern= /^\d{3}\.\d{2}$/;
    const waistDifferenceBaselinePattern= /^\d{3}\.\d{2}$/;
    const asanaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const triphalaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const yavaQuantityPreviousPattern = /^\d{3}$/;  // 3 digits followed by 'g'
  const asanaIdealConsumedPattern = /^\d{3}$/; 
  const asanaConsumedPattern = /^\d{3}$/;
  const triphalaConsumedPattern = /^\d{3}$/;
  const triphalaIdealConsumedPattern = /^\d{3}$/;
  const yavaConsumedPattern = /^\d{3}$/;
  const yavaIdealConsumedPattern = /^\d{3}$/;
  const asanaQuantityCurrentPattern = /^\d{3}$/;
  const triphalaQuantityCurrentPattern = /^\d{3}$/;
  const yavaQuantityCurrentPattern = /^\d{3}$/;
  

    const { weight, height, waistCircumference,waistDifferenceBaseline,waistDifferencePrevious,weightLossBaseline, weightLossPrevious,asanaQuantityPrevious,triphalaQuantityPrevious,yavaQuantityPrevious,asanaIdealConsumed,asanaConsumed,triphalaConsumed,triphalaIdealConsumed,yavaConsumed,yavaIdealConsumed,asanaQuantityCurrent,triphalaQuantityCurrent,yavaQuantityCurrent } = this.formData;
    
    // Only validate fields if they are not empty
    if (weight && !weightPattern.test(weight)) {
      alert("Invalid weight format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (height && !heightPattern.test(height)) {
      alert("Invalid height format. Please enter in 00.00 m format.");
      return;
    }
  
    if (waistCircumference && !waistPattern.test(waistCircumference)) {
      alert("Invalid waist circumference format. Please enter in 000.00 cm format.");
      return;
    }
    if (weightLossPrevious && !weightLossPreviousPattern.test(weightLossPrevious)) {
      alert("Invalid weightLossPrevious format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (weightLossBaseline && !weightLossBaselinePattern.test(weightLossBaseline)) {
      alert("Invalid weightLossBaseline format. Please enter in 000.00 kg format.");
      return;
    }
  
    if (waistDifferencePrevious && !waistDifferencePreviousPattern.test(waistDifferencePrevious)) {
      alert("Invalid waistDifferencePrevious format. Please enter in 000.00 cm format.");
      return;
    }
  
    if (waistDifferenceBaseline && !waistDifferenceBaselinePattern.test(waistDifferenceBaseline)) {
      alert("Invalid waistDifferenceBaseline format. Please enter in 000.00 cm format.");
      return;
    }
    // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaQuantityPrevious && !asanaQuantityPreviousPattern.test(asanaQuantityPrevious)) {
    alert("Invalid asanaQuantityPrevious format. Please enter in 123g format (3 digits).");
    return;
  }
   // Validate the new asanaChurnaQuantity field using this.formData
   if (triphalaQuantityPrevious && !triphalaQuantityPreviousPattern.test(triphalaQuantityPrevious)) {
    alert("Invalid triphalaQuantityPrevious format. Please enter in 123g format (3 digits).");
    return;
  }
   // Validate the new asanaChurnaQuantity field using this.formData
   if (yavaQuantityPrevious && !yavaQuantityPreviousPattern.test(yavaQuantityPrevious)) {
    alert("Invalid yavaQuantityPrevious  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaIdealConsumed && !asanaIdealConsumedPattern.test(asanaIdealConsumed)) {
    alert("Invalid asanaIdealConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaConsumed && !asanaConsumedPattern.test(asanaConsumed)) {
    alert("Invalid asanaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaConsumed && !triphalaConsumedPattern.test(triphalaConsumed)) {
    alert("Invalid triphalaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaIdealConsumed && !triphalaIdealConsumedPattern.test(triphalaIdealConsumed)) {
    alert("Invalid yavaChurnaQuantity  format. Please enter in 123g format (3 digits).");
    return;
  }
  
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaConsumed && !yavaConsumedPattern.test(yavaConsumed)) {
    alert("Invalid yavaConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaIdealConsumed && !yavaIdealConsumedPattern.test(yavaIdealConsumed)) {
    alert("Invalid yavaIdealConsumed  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (asanaQuantityCurrent && !asanaQuantityCurrentPattern.test(asanaQuantityCurrent)) {
    alert("Invalid asanaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (triphalaQuantityCurrent && !triphalaQuantityCurrentPattern.test(triphalaQuantityCurrent)) {
    alert("Invalid triphalaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  // Validate the new asanaChurnaQuantity field using this.formData
  if (yavaQuantityCurrent && !yavaQuantityCurrentPattern.test(yavaQuantityCurrent)) {
    alert("Invalid yavaQuantityCurrent  format. Please enter in 123g format (3 digits).");
    return;
  }
  
    // If all are valid, submit the form
    this.submitForm();
  }

  submitForm() {
    if (this.formData.vitalSigns === 'no' && (!this.formData.vitalSignsComments || this.formData.vitalSignsComments.trim() === '')) {
      alert('Comments are required when "No" is selected.');
      return;
    }
    let questionAnswers: { [key: string]: any } = {};

    if (this.formName && this.questionMapping[this.formName]) {
        this.questionMapping[this.formName].forEach(mapping => {
            let fieldKey = mapping.question; // Use question text as key

            if (this.formName === 'medicine-vital-signs') {
              if (mapping.field === 'vitalSigns' && this.formData.vitalSigns === 'no') {
                  questionAnswers[fieldKey] = {
                      answer: "no",
                      value: this.formData.vitalSignsComments
                  };
              } else {
                  questionAnswers[fieldKey] = this.formData[mapping.field];
              }
            }else if (this.formName === 'medicine-product-retrieval') {
              if (mapping.field === 'productRetrieved' && this.formData.productRetrieved === 'no') {
                  questionAnswers[fieldKey] = {
                      answer: "no",
                      value: this.formData.studyComments
                  };
              } else {
                  questionAnswers[fieldKey] = this.formData[mapping.field];
              }
            }
            //medicine-product-retrieval
            else if (this.formName === 'medicine-product-compliance') {
              // Asana Churna Section
              if (mapping.field === 'asanaCompliance') {
                  if (this.formData.asanaCompliance === 'no') {
                      questionAnswers[fieldKey] = {
                          answer: "no",
                          value: this.formData.studyComplianceComments
                      };
                  } else {
                      questionAnswers[fieldKey] = this.formData[mapping.field];
                  }
              }
              // Triphala Tablet Section
              else if (mapping.field === 'triphalaCompliance') {
                  if (this.formData.triphalaCompliance === 'no') {
                      questionAnswers[fieldKey] = {
                          answer: "no",
                          value: this.formData.triphalaComplianceComments
                      };
                  } else {
                      questionAnswers[fieldKey] = this.formData[mapping.field];
                  }
              }
              // Yava Churna Section
              else if (mapping.field === 'yavaCompliance') {
                  if (this.formData.yavaCompliance === 'no') {
                      questionAnswers[fieldKey] = {
                          answer: "no",
                          value: this.formData.yavaComplianceComments
                      };
                  } else {
                      questionAnswers[fieldKey] = this.formData[mapping.field];
                  }
              }
              else {
                questionAnswers[fieldKey] = this.formData[mapping.field];
            }
        }
        else if (this.formName === 'medicine-product-dispensing-record') {
          // Handle the medicine-product-dispensing-record form fields
          if (mapping.field === 'dispensedProtocol' && this.formData.dispensedProtocol === 'no') {
              questionAnswers[fieldKey] = {
                  answer: "no",
                  value: this.formData.dispensedProtocolComments
              };
          } else if (mapping.field === 'logGiven' && this.formData.logGiven === 'no') {
              questionAnswers[fieldKey] = {
                  answer: "no",
                  value: this.formData.logGivenComments
              };
          } else {
              questionAnswers[fieldKey] = this.formData[mapping.field];
          }}
          

            else  {
              questionAnswers[fieldKey] = this.formData[mapping.field];
          }
        });
    }
    const submittedData = {
      folderName: "medicine-dispensing-visit",
      formName: this.formName,
      studyId: this.studyId,
      subjectId: this.subjectId,
      //...this.formData
      ...questionAnswers
    };

    console.log("Form Submitted:", submittedData);

    this.apiService.insertFormData(submittedData).subscribe({
      next: (response) => {
        console.log("Response from API:", response);
        alert("Form Submitted Successfully!");
      },
      error: (error) => {
        console.error("Error submitting form:", error);
        alert("Error submitting form. Please try again.");
      }
    });
  }
  insertFormData(submittedData: { folderName: string | null; formName: string | null; studyId: string | null; subjectId: string | null; }) {
    throw new Error('Method not implemented.');
  }
  goBack() {
    this.router.navigate(['/study-details', this.studyId]);
  }

  createField() {
    alert("Create Field Clicked!");
  }
  checkVitalSigns() {
    if (this.formData.vitalSigns === 'no') {
      this.formData.vitalSignsComments = '';
    }
  }
}
